// extracted by mini-css-extract-plugin
module.exports = {"loading":"TheWrapper_loading_2LuRU"};